// Enhanced platform detection: Distinguishes between native apps and mobile browsers
let Device, Capacitor;

// Try to import Capacitor modules (will work in native app, fail in browser)
try {
  const DeviceModule = require('@capacitor/device');
  Device = DeviceModule.Device;
} catch (e) {
  console.log('Capacitor Device not available - running in browser mode');
}

try {
  const CapacitorCore = require('@capacitor/core');
  Capacitor = CapacitorCore.Capacitor;
} catch (e) {
  console.log('Capacitor Core not available - running in browser mode');
}

/**
 * Detect if running in native app or mobile browser
 * Returns:
 * - 'android' - Android native app (Capacitor)
 * - 'android_browser' - Chrome/Firefox on Android device
 * - 'ios' - iOS native app (Capacitor)
 * - 'ios_browser' - Safari on iOS device
 * - 'web' - Desktop browser
 */
export const platformInfo = async () => {
  try {
    // Check if Capacitor is available (native app)
    const isNativeApp = Capacitor && Capacitor.isNativePlatform && Capacitor.isNativePlatform();
    
    if (isNativeApp && Device) {
      // Running in native app - use Capacitor
      const device = await Device.getInfo();
      const id = await Device.getId();

      console.log("✅ Capacitor Native App Detected");
      console.log("Device Info:", device);
      console.log("Device ID:", id);

      const platformInfo = {
        os: device.operatingSystem, // 'android' or 'ios'
        model: device.model,
        uuid: id.identifier,
        platform: device.platform,
        isNative: true,
        isApp: true,
        isBrowser: false,
        environment: 'native_app'
      };
      
      console.log("Platform Info:", platformInfo);
      return platformInfo;
    } else {
      // Running in browser - detect from user agent
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      let detectedOS = 'web';
      let isAndroid = /android/i.test(userAgent);
      let isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
      
      if (isAndroid) {
        detectedOS = 'android_browser';
      } else if (isIOS) {
        detectedOS = 'ios_browser';
      }

      console.log("🌐 Browser Mode Detected");
      console.log("User Agent:", userAgent);
      console.log("Detected OS:", detectedOS);

      const platformInfo = {
        os: detectedOS, // 'android_browser', 'ios_browser', or 'web'
        model: isAndroid ? 'Android Device' : isIOS ? 'iOS Device' : 'Desktop',
        uuid: null,
        platform: isAndroid ? 'android' : isIOS ? 'ios' : 'web',
        isNative: false,
        isApp: false,
        isBrowser: true,
        environment: isAndroid || isIOS ? 'mobile_browser' : 'desktop_browser'
      };

      console.log("Platform Info:", platformInfo);
      return platformInfo;
    }
  } catch (error) {
    console.error("Error detecting platform:", error);
    
    // Fallback: Basic detection
    const userAgent = navigator.userAgent || '';
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    
    return {
      os: isAndroid ? 'android_browser' : isIOS ? 'ios_browser' : 'web',
      model: 'Unknown',
      uuid: null,
      platform: isAndroid ? 'android' : isIOS ? 'ios' : 'web',
      isNative: false,
      isApp: false,
      isBrowser: true,
      environment: 'unknown'
    };
  }
};

// Export the function
export const getPlatform = platformInfo;

// Export default as the platform info object
export default platformInfo;



  
